function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 30 30.266"
  }, props), /*#__PURE__*/React.createElement("text", {
    x: 5.078,
    y: 24.625,
    style: {
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    fontWeight: 400,
    fontSize: 32,
    fontFamily: "sans-serif",
    fill: "currentColor",
    strokeWidth: 0
  }, "$"));
};
export default SvgDollar;